import axios from "../utiles/axios.util";

function apiGetWorkMng(spt_se, keyword) {
    return axios.get(`/api/v1/workMng?spt_se=${spt_se}&keyword=${keyword}`);
}

function apiGetWorkMngDetail(rcvord_no) {
    return axios.get(`/api/v1/workMng/detail?rcvord_no=${rcvord_no}`);
}

function apiPutWorkMng(formData) {
    return axios.put("/api/v1/workMng", formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
}

export { apiGetWorkMng, apiGetWorkMngDetail, apiPutWorkMng };
